<div class="with-floating-button">
    <div class="content">
        <page-header
                *ngIf="isDisplayed"
                [title]="'admin.bibliotheque.internationalisation.title' | translate"
                [listeItems]="listeTabItems"
                [selectedIndex]="selectedIndex"
                (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>
        <router-outlet></router-outlet>
    </div>
    <floating-button *ngIf="isDisplayed" [listeActions]="listeActions"></floating-button>
</div>
